// extracted by mini-css-extract-plugin
module.exports = {"content":"item-card_content__3o-wJ","title":"item-card_title__3CljE","main":"item-card_main__1ySt-","description":"item-card_description__2SMwz","score":"item-card_score__2fJzC"};